import React from 'react';
import './style.scss';
import { CategoriesRendererComponent, CategoriesRendererProps } from './types';

const CategoriesAccordion: CategoriesRendererComponent = ({
    categories = [],
    currentCategoryIndex,
    onOpenCategory = () => {},
    onCloseCategory = () => {},
    children,
}: CategoriesRendererProps) => <div className="categories-accordion">
    {categories.map(({imageUrl, label, action, products, productIds}, i) =>
        <div className="category" key={i}>
            <a className="category-header-wrapper"
                    href={(
                        action === 'productPage' &&
                        products &&
                        productIds &&
                        productIds[0] &&
                        products[productIds[0]] &&
                        products[productIds[0]].detailPageUrl
                    ) ?
                        products[productIds[0]].detailPageUrl :
                        undefined
                    }
                    onClick={action === 'popup' ? toggle(
                        i,
                        currentCategoryIndex,
                        onOpenCategory,
                        onCloseCategory
                    ) : undefined}>
                <div className="category-header">
                    <div className="category-icon">
                        <img src={imageUrl} />
                    </div>
                    <div className="category-label">{label}</div>
                </div>
            </a>
            {(currentCategoryIndex === i) && children}
        </div>
    )}
</div>;

const toggle = (
    i: number,
    currentCategoryIndex: number,
    onOpen: (i: number) => void,
    onClose: () => void
) => () => (i === currentCategoryIndex) ? onClose() : onOpen(i);

export default CategoriesAccordion;
